import envConfig from '../../static/config';
import config from '../config';
import ApiUtils from './ApiUtils';
import FinancialStoriesActionCreator from '../actions/FinancialStoriesActionCreator';
import FinancialStoriesParser from '../parsers/FinancialStoriesParser';

const _getFSConMicroTransactionsEndpoint =
  '/ibapi/v2/banks/{bank-id}/accounts/default/transactions/aggregations/microTransactions';
const _getFSConCashpointEndpoint =
  '/ibapi/v2/banks/{bank-id}/accounts/default/transactions/aggregations/cashpoint';
const _getFSConInsAndOutsEndpoint =
  '/ibapi/v2/banks/{bank-id}/accounts/default/transactions/aggregations/insAndOuts';

class FinancialStoriesApiUtils {
  static getFinancialStoriesConnection(
    type,
    accountId,
    month,
    count,
    updateQuery
  ) {
    let url = '';
    let requestData;
    switch (type) {
      case 'microTransactions':
        url = _getFSConMicroTransactionsEndpoint;
        requestData = FinancialStoriesParser.getMicroTransactionsPacket(
          accountId,
          month,
          count
        );
        break;

      case 'insAndOuts':
        url = _getFSConInsAndOutsEndpoint;
        requestData = FinancialStoriesParser.getInsAndOutsPacket(
          accountId,
          month,
          count
        );
        break;

      case 'cashpoint':
        url = _getFSConCashpointEndpoint;
        requestData = FinancialStoriesParser.getCashpointPacket(
          accountId,
          month,
          count
        );
        break;
    }
    url = envConfig.apiBaseUrlPAAS + url;
    let method = 'POST';
    if (envConfig.stubConfig) {
      url =
        envConfig.stubConfig.financialStoresStub
          .FinancialStoriesConnectionMicroTransactions;
      method = 'GET';
    }
    ApiUtils.makeAjaxCall(
      {
        apiVersion: config.apiVersions.accountTranService,
        method,
        url,
        addAuthToken: true,
        requestData,
      },
      (body) => {
        FinancialStoriesActionCreator.handleFinancialStoriesConnectionSuccess(
          type,
          body,
          accountId,
          month.month,
          updateQuery
        );
      },
      (error) => {
        FinancialStoriesActionCreator.handleFinancialStoriesConnectionError(
          error,
          type,
          updateQuery
        );
      }
    );
  }
}

export default FinancialStoriesApiUtils;
